import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseChartDirective } from 'ng2-charts';

import { SessionService } from './../../services/session.service';

import { Factura } from './../../entities/factura.entity';
import { ChartData, ChartType } from 'chart.js';

@Component({
  selector: 'bar-chart-demo',
  templateUrl: './grafico.component.html'
})
export class GraficoComponent implements OnInit {
  public static UpdateData: Subject<Factura[]> = new Subject();
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() grafica: Factura[];

  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  public barChartData: ChartData<'bar'>;
  public colorCampos: string[];
  public lineChartColors = [{ backgroundColor: [] }];
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  private _colors = ["rgb(248,0,0)", "rgb(0,44,88)", "rgb(0,175,210)"];
  private _colorsHover = ["rgb(190,0,0)", "rgb(0,30,60)", "rgb(0,100,120)"];

  constructor(private sessionService: SessionService) {
    this.barChartLabels = [];
    this.barChartData = undefined;
    GraficoComponent.UpdateData.subscribe(res => {
      this.CargarDatos(res);
    });
  }

  ngOnInit() {
    this.barChartLabels = [];
    this.barChartData = undefined;
    if (this.grafica !== undefined) {
      this.CargarDatos(this.grafica);
    }
  }

  public CargarDatos(datos: Factura[]) {
    datos = datos.filter(x => x.FechaLecturaFactura !== null);
    this.barChartLabels = this.getChartData_Label(datos);

    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [{
        label: '',
        data: this.getChartData_Data(datos),
        backgroundColor: this.getChartData_Color(datos),
        hoverBackgroundColor: this.getChartData_Color(datos, true),
      }]
    };
  }

  private getChartData_Label(datos: Factura[]) {
    let i = 1;
    let _result: string[] = [];
    for (const factura of datos) {
      if (i <= 6) {
        _result.push(factura.Periodo.Descripcion);
        i++;
      }
    }
    return _result;
  }

  private getChartData_Data(datos: Factura[]) {
    let i = 1;
    let _result: number[] = [];
    for (const factura of datos) {
      if (i <= 6) {
        _result.push(!this.sessionService.isEmmasa ? factura.ConsumoReal : factura.ConsumoFactura);
        i++;
      }
    }
    return _result;
  }

  private getChartData_Color(datos: Factura[], getHover: boolean = false) {
    let i = 0;
    let _result: string[] = [];
    for (const factura of datos) {
      if (i <= datos.length) {
        if (i === 0) {
          _result.push(getHover ? this._colorsHover[2] : this._colors[2]);
        } else if ((factura.TotalCobrado < factura.TotalFacturado) && factura.Fecha !== null) {
          _result.push(getHover ? this._colorsHover[0] : this._colors[0]);
        } else {
          _result.push(getHover ? this._colorsHover[1] : this._colors[1]);
        }
        i++;
      }
    }
    return _result;
  }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }
}
